var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 74,
    viewBox: "0 0 64 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7783 52.6927H6.10583C3.32083 52.6927 1 55.0136 1 57.7986C1 60.5836 3.32083 62.9044 6.10583 62.9044H29.7783",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98981 59.6553C7.03418 59.6553 7.96251 58.843 7.96251 57.6825C7.96251 56.6382 7.15022 55.7098 5.98981 55.7098",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9079 57.7986H27.6896",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98981 69.867C7.03418 69.867 7.96251 69.0547 7.96251 67.8943C7.96251 66.7338 7.03418 66.0376 5.98981 66.0376",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9079 67.8943H27.6896",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7783 62.7883H6.10583C3.32083 62.7883 1 65.1092 1 67.8942C1 70.6792 3.32083 73 6.10583 73H29.7783",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7477 50.3719V37.0271C44.7477 35.9827 43.9354 35.1704 42.891 35.1704C41.8466 35.1704 41.0344 35.9827 41.0344 37.0271V54.8975C41.0344 55.4777 40.3381 55.9419 39.8739 55.4777C39.1777 54.8975 38.3654 53.9691 38.1333 52.3446C38.1333 52.3446 37.7852 50.836 36.0446 50.3719C35.3483 50.2558 34.6521 50.836 34.8841 51.5323L36.1606 56.29C36.5087 57.4504 36.8569 58.4948 37.321 59.5391C38.3654 61.7439 40.3381 65.4573 41.6146 66.0375",
    stroke: "#FDC20C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7477 45.3821C44.7477 44.3377 45.56 43.5254 46.6043 43.5254C47.6487 43.5254 48.461 44.3377 48.461 45.3821V50.3718",
    stroke: "#FDC20C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.577 46.7746C48.577 45.7303 49.3893 44.918 50.4337 44.918C51.4781 44.918 52.2904 45.7303 52.2904 46.7746V50.488",
    stroke: "#FDC20C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2904 48.051C52.2904 47.0066 53.1027 46.1943 54.1471 46.1943C55.1914 46.1943 56.0037 47.0066 56.0037 48.051V50.4879V59.7712C56.0037 61.7439 55.7717 63.7166 55.1914 65.5733L55.0754 66.1535",
    stroke: "#FDC20C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6829 73H41.9627C40.3381 73 38.9456 71.7236 38.9456 69.9829V69.1706C38.9456 67.5461 40.2221 66.1536 41.9627 66.1536H53.6829C55.3075 66.1536 56.7 67.43 56.7 69.1706V69.9829C56.7 71.7236 55.3075 73 53.6829 73Z",
    stroke: "#FDC20C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2391 70.9113C43.9441 70.9113 44.5156 70.3398 44.5156 69.6349C44.5156 68.9299 43.9441 68.3584 43.2391 68.3584C42.5341 68.3584 41.9626 68.9299 41.9626 69.6349C41.9626 70.3398 42.5341 70.9113 43.2391 70.9113Z",
    stroke: "#FDC20C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6931 36.0988C52.8706 35.1704 56.3518 35.4025 56.3518 35.4025V1.05422C56.3518 1.05422 43.5872 0.00984423 36.5087 7.08838C29.4302 0.00984423 16.6656 1.05422 16.6656 1.05422V35.4025C16.6656 35.4025 30.4745 34.5902 36.5087 43.2934",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5087 7.20447V43.4094",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3689 43.4094C61.2256 43.4094 62.6181 41.9008 62.6181 40.1602V11.4979C62.6181 9.64128 61.1095 8.24878 59.3689 8.24878H56.2358",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6656 8.24878H13.5325C11.6758 8.24878 10.2833 9.75732 10.2833 11.4979V40.0442C10.2833 41.9008 11.7919 43.2933 13.5325 43.2933H36.5087",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9592 7.20438C25.6008 6.85625 28.966 7.90063 32.5633 10.6856",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9592 11.73C25.6008 11.3819 28.966 12.4263 32.5633 15.2113",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9592 16.1396C25.6008 15.7914 28.966 16.8358 32.5633 19.6208",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9592 20.6652C25.6008 20.3171 28.966 21.3614 32.5633 24.1464",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9592 25.1908C25.6008 24.8427 28.966 25.8871 32.5633 28.6721",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9592 29.6005C25.6008 29.2524 28.966 30.2967 32.5633 33.0817",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0583 7.20438C47.4166 6.85625 44.0514 7.90063 40.4541 10.6856",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0583 11.73C47.4166 11.3819 44.0514 12.4263 40.4541 15.2113",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0583 16.1396C47.4166 15.7914 44.0514 16.8358 40.4541 19.6208",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0583 20.6652C47.4166 20.3171 44.0514 21.3614 40.4541 24.1464",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0583 25.1908C47.4166 24.8427 44.0514 25.8871 40.4541 28.6721",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0583 29.6004C50.2016 29.4844 48.577 29.4844 46.9525 29.8325",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo03);
export default __webpack_public_path__ + "static/media/logo03.0af5e6635831c6a50d35031ec7a0e569.svg";
export { ForwardRef as ReactComponent };